/* Collection page below the grid (sections/plp-bottom.liquid): rail arrows, active size card while swiping, before/after drag,
   community videos that load + play only while visible, sound toggle. No dependencies. */
(function () {
  'use strict';
  /* the section is used several times on the page and each instance includes this file: run it only once */
  if (window.__plpbLoaded) return;
  window.__plpbLoaded = true;

  function initRails(root) {
    root.querySelectorAll('.plpb-block').forEach(function (block) {
      var rail = block.querySelector('[data-plpb-rail]');
      var nav = block.querySelector('[data-plpb-nav]');
      if (!rail || !nav) return;
      var prev = nav.querySelector('[data-dir="-1"]');
      var next = nav.querySelector('[data-dir="1"]');
      var update = function () {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
        nav.hidden = max <= 0;
      };
      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-dir]');
        if (!btn) return;
        /* one card per click (card width + gap); native swipe stays as it is */
        var item = rail.querySelector(':scope > li');
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        var step = item ? item.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
        rail.scrollBy({ left: Number(btn.dataset.dir) * step, behavior: 'smooth' });
      });
      rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* size slider: on touch screens the card closest to the left edge is highlighted (lime) */
  function initSizes(root) {
    var rail = root.querySelector('[data-plpb-sizes]');
    if (!rail || !('IntersectionObserver' in window)) return;
    if (!window.matchMedia('(hover: none)').matches) return;
    var items = Array.prototype.slice.call(rail.children);
    var pick = function () {
      var left = rail.getBoundingClientRect().left;
      var best = null;
      var bestD = Infinity;
      items.forEach(function (li) {
        var d = Math.abs(li.getBoundingClientRect().left - left - 20);
        if (d < bestD) { bestD = d; best = li; }
      });
      items.forEach(function (li) { li.classList.toggle('is-active', li === best); });
    };
    var t;
    rail.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(pick, 60); }, { passive: true });
    pick();
  }

  function initVideos(root) {
    var boxes = root.querySelectorAll('[data-plpb-video]');
    if (!boxes.length) return;
    /* posters (data-poster) load only shortly before a card comes into view: a poster attribute downloads at once */
    var setPoster = function (v) { if (v && v.dataset.poster) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); } };
    if ('IntersectionObserver' in window) {
      var pio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { setPoster(en.target.querySelector('video')); pio.unobserve(en.target); } });
      }, { rootMargin: '600px 600px' });
      boxes.forEach(function (b) { pio.observe(b); });
    } else boxes.forEach(function (b) { setPoster(b.querySelector('video')); });
    var play = function (v) {
      if (v.preload === 'none') v.preload = 'metadata';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };
    /* no autoplay with "reduce motion" or the data saver: the poster stays, the sound button still starts a clip */
    var still = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || (navigator.connection && navigator.connection.saveData);
    if (!still && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target.querySelector('video');
          if (!v) return;
          if (en.isIntersecting) { if (!document.hidden) play(v); } else v.pause();
        });
      }, { threshold: 0.35 });
      boxes.forEach(function (b) { io.observe(b); });
    }

    root.addEventListener('click', function (e) {
      var item = e.target.closest('.plpb-reel__item.is-video');
      var btn = item && item.querySelector('[data-plpb-sound]');
      if (!btn) return;
      var v = item && item.querySelector('video');
      if (!v) return;
      var turnOn = btn.getAttribute('aria-pressed') !== 'true';
      root.querySelectorAll('[data-plpb-sound]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        var ov = b.closest('li') && b.closest('li').querySelector('video');
        if (ov) ov.muted = true;
      });
      if (turnOn) {
        v.muted = false;
        btn.setAttribute('aria-pressed', 'true');
        play(v);
      }
    });
  }

  /* Visible height budget = viewport minus the sticky top bar and the fixed bottom cart bar (plp-sticky-cart). */
  function occlusion() {
    var top = 0;
    document.querySelectorAll('.shopify-section-group-header-group, .mobile-sticky-bar, [data-mobile-sticky-bar]').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || (cs.position !== 'sticky' && cs.position !== 'fixed')) return;
      top = Math.max(top, el.getBoundingClientRect().height);
    });
    var bottom = 0;
    var bar = document.querySelector('[data-plp-sticky-cart]') || document.querySelector('sticky-atc.sticky-reward-atc'); /* product page: reward bar */
    if (bar) {
      var bs = getComputedStyle(bar);
      if (bs.display !== 'none' && bs.position === 'fixed') bottom = Math.max(0, window.innerHeight - bar.getBoundingClientRect().top);
    }
    return { top: Math.round(top), bottom: Math.round(bottom) };
  }

  /* Reviews + before/after: photo height so heading, cards and button fit into the visible height at once. */
  function fit() {
    var o = occlusion();
    var avail = window.innerHeight - o.top - o.bottom - 28;
    document.querySelectorAll('.plpb [data-plpb-fit]').forEach(function (block) {
      if (block.querySelector('.plpb-rev.is-open')) return;
      /* studio size tiles are not fitted any more: fixed size in CSS (N2) */
      var isBa = block.classList.contains('plpb-ba');
      var min = 110;
      var max = 280;
      if (isBa) {
        /* before / after: tall 3:4 photo; on phones not much taller than the column width allows */
        var col = block.querySelector('.plpb-ba__col');
        min = 300;
        max = 720;
        if (col && window.innerWidth < 990) max = Math.max(min, Math.min(max, Math.round(col.clientWidth / 0.75 * 1.06)));
      }
      for (var pass = 0; pass < 2; pass++) {
        var media = block.querySelector('.plpb-rev__img, .plpb-size__media, .plpb-ba__fig');
        var wrap = block.querySelector('.plpb-wrap');
        if (!media || !wrap) return;
        var fixed = wrap.getBoundingClientRect().height - media.getBoundingClientRect().height;
        var h = Math.max(min, Math.min(max, Math.floor(avail - fixed)));
        block.style.setProperty('--plpb-media-h', h + 'px');
      }
      block.setAttribute('data-plpb-budget', avail + '/' + o.top + '/' + o.bottom);
    });
    checkMore();
  }

  function checkMore() {
    document.querySelectorAll('.plpb-rev:not(.is-open)').forEach(function (li) {
      var q = li.querySelector('.plpb-rev__q');
      var btn = li.querySelector('[data-plpb-more]');
      if (q && btn) btn.hidden = !(q.scrollHeight > q.clientHeight + 2);
    });
  }

  function initMore(root) {
    root.querySelectorAll('.plpb-rev').forEach(function (li) {
      var q = li.querySelector('.plpb-rev__q');
      var btn = li.querySelector('[data-plpb-more]');
      if (!q || !btn) return;
      if (!btn.dataset.more) btn.dataset.more = btn.textContent;
    });
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-plpb-more]');
      if (!btn) return;
      var li = btn.closest('.plpb-rev');
      var open = li.classList.toggle('is-open');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Review photo popup: whole photo uncropped + full review (stars, text, name, date, product link).
     X / backdrop / Esc close it, body scroll is locked, prev/next when a review has several photos. */
  var lb = null;
  var lbLast = null;
  function lbBuild(labels) {
    lb = document.createElement('div');
    lb.className = 'plpb-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    var arrow = function (d) { return '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
    lb.innerHTML = '<div class="plpb-lb__box"><div class="plpb-lb__media"><button type="button" class="plpb-lb__step" data-step="-1"></button><div class="plpb-lb__slot" style="display:contents"></div><button type="button" class="plpb-lb__step" data-step="1"></button><span class="plpb-lb__n"></span></div><div class="plpb-lb__textslot" style="display:contents"></div><button type="button" class="plpb-lb__x"></button></div>';
    var x = lb.querySelector('.plpb-lb__x');
    x.setAttribute('aria-label', labels.close || 'Close');
    x.innerHTML = arrow('M6 6l12 12M18 6L6 18');
    var prev = lb.querySelector('[data-step="-1"]');
    var next = lb.querySelector('[data-step="1"]');
    prev.setAttribute('aria-label', labels.prev || 'Previous');
    next.setAttribute('aria-label', labels.next || 'Next');
    prev.innerHTML = arrow('M15 5l-7 7 7 7');
    next.innerHTML = arrow('M9 5l7 7-7 7');
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('.plpb-lb__x')) { lbClose(); return; }
      var st = e.target.closest('[data-step]');
      if (st) lbShow(lb._i + Number(st.dataset.step));
    });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); lbClose(); }
      else if (e.key === 'ArrowLeft') lbShow(lb._i - 1);
      else if (e.key === 'ArrowRight') lbShow(lb._i + 1);
      else if (e.key === 'Tab') {
        var f = Array.prototype.filter.call(lb.querySelectorAll('button, a[href]'), function (el) { return !el.hidden && el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    document.body.appendChild(lb);
  }
  function lbShow(i) {
    var imgs = lb.querySelectorAll('.plpb-lb__pics img');
    if (!imgs.length) return;
    i = (i + imgs.length) % imgs.length;
    lb._i = i;
    Array.prototype.forEach.call(imgs, function (im, k) { im.classList.toggle('is-on', k === i); });
    var many = imgs.length > 1;
    lb.querySelectorAll('[data-step]').forEach(function (b) { b.hidden = !many; });
    var n = lb.querySelector('.plpb-lb__n');
    n.hidden = !many;
    n.textContent = (i + 1) + ' / ' + imgs.length;
  }
  function lbOpen(trigger) {
    var tpl = trigger.parentElement.querySelector('template[data-plpb-lb-data]');
    if (!tpl) return;
    var root = document.querySelector('.plpb[data-lb-close]') || {};
    var ds = root.dataset || {};
    if (!lb) lbBuild({ close: ds.lbClose, prev: ds.lbPrev, next: ds.lbNext });
    var frag = tpl.content.cloneNode(true);
    var pics = frag.querySelector('.plpb-lb__pics');
    var text = frag.querySelector('.plpb-lb__text');
    var slot = lb.querySelector('.plpb-lb__slot');
    var tslot = lb.querySelector('.plpb-lb__textslot');
    slot.innerHTML = '';
    tslot.innerHTML = '';
    if (pics) slot.appendChild(pics);
    if (text) tslot.appendChild(text);
    lbShow(0);
    lbLast = trigger;
    lb.hidden = false;
    document.documentElement.classList.add('plpb-lb-lock');
    window.requestAnimationFrame(function () { lb.classList.add('is-open'); });
    lb.querySelector('.plpb-lb__x').focus({ preventScroll: true });
  }
  function lbClose() {
    if (!lb || lb.hidden) return;
    lb.classList.remove('is-open');
    lb.hidden = true;
    document.documentElement.classList.remove('plpb-lb-lock');
    if (lbLast) lbLast.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lb && !lb.hidden && !lb.contains(e.target)) lbClose();
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.plpb [data-plpb-lb]');
    if (!t) return;
    e.preventDefault();
    lbOpen(t);
  });

  /* before / after: the range input (keyboard, screen readers) and a pointer drag on the whole photo (mouse + touch)
     move the split (--x); a short hint swing the first time it comes into view. Same mechanics as assets/hw-landing.js. */
  function initBa(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-plpb-ba]').forEach(function (ba) {
      var range = ba.querySelector('.plpb-ba__range');
      if (!range) return;
      var setX = function (v) { ba.style.setProperty('--x', v + '%'); };
      range.addEventListener('input', function () { ba.__touched = true; setX(range.value); });
      var drag = false;
      var moveTo = function (e) {
        var r = ba.getBoundingClientRect();
        var v = Math.round((e.clientX - r.left) / r.width * 1000) / 10;
        v = Math.max(0, Math.min(100, v));
        range.value = Math.round(v);
        setX(v);
      };
      ba.addEventListener('pointerdown', function (e) {
        drag = true; ba.__touched = true; ba.classList.add('is-drag'); moveTo(e);
        if (ba.setPointerCapture) try { ba.setPointerCapture(e.pointerId); } catch (er) {}
      });
      ba.addEventListener('pointermove', function (e) { if (drag) moveTo(e); });
      var end = function () { drag = false; ba.classList.remove('is-drag'); };
      ba.addEventListener('pointerup', end);
      ba.addEventListener('pointercancel', end);
      if (reduce || !('IntersectionObserver' in window)) return;
      var hinted = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting || hinted || ba.__touched) return;
          hinted = true;
          var t0 = performance.now(), dur = 1800;
          (function swing(now) {
            if (ba.__touched) return;
            var t = Math.min(1, (now - t0) / dur), v = 50 + Math.sin(t * Math.PI * 2) * 22 * (1 - t);
            range.value = Math.round(v);
            setX(v.toFixed(1));
            if (t < 1) window.requestAnimationFrame(swing);
          })(t0);
        });
      }, { threshold: 0.6 }).observe(ba);
    });
  }

  var fitT;
  function fitSoon() { clearTimeout(fitT); fitT = setTimeout(fit, 120); }

  function init() {
    document.querySelectorAll('.plpb').forEach(function (root) {
      if (root.dataset.plpbInit) return;
      root.dataset.plpbInit = '1';
      initRails(root);
      initSizes(root);
      initVideos(root);
      initMore(root);
      initBa(root);
    });
    fit();
  }
  window.addEventListener('resize', fitSoon);
  window.addEventListener('load', fitSoon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSoon);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

// FILTER ACCORDION MEMORY (2026-10-18): open/closed filter groups are remembered for this browser session, also after
// a reload or an AJAX filter update. Groups with a selected value are opened by the server (snippets/faceted-filters).
(function () {
  var KEY = 'tt-filter-open';
  var read = function () { try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
  var write = function (o) { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} };
  var isOpen = function (t) { var el = document.querySelector(t.dataset.toggleTarget); return el && !el.classList.contains('toggle-target--hidden'); };
  var apply = function () {
    var state = read();
    document.querySelectorAll('toggle-target[data-fg-key]').forEach(function (t) {
      var want = state[t.dataset.fgKey]; var el = document.querySelector(t.dataset.toggleTarget);
      if (!el) return;
      var active = el.querySelector('.filter-group__item--active, input:checked');
      if (want === undefined && !active) return;
      var open = !!want || !!active;
      el.classList.toggle('toggle-target--hidden', !open);
      t.classList.toggle('toggle-target-toggler--is-hidden', !open);
    });
  };
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('toggle-target[data-fg-key]'); if (!t) return;
    var wasOpen = isOpen(t); var s = read(); s[t.dataset.fgKey] = !wasOpen; write(s);
  }, true);
  // the theme re-renders the filter panel after load / on every filter change, so watch the page, not one element
  var queued = false;
  var schedule = function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; apply(); }); };
  var init = function () {
    if (window.__ttFilterMemory) return; window.__ttFilterMemory = true;
    apply();
    new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) { if (m[i].addedNodes.length) { schedule(); return; } } }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
